module.exports = __webpack_public_path__ + "img/fig03.f7d14ed6.jpg";